import React from 'react';
import { Tarif } from '../data/zooData';

interface PricingCardProps {
  tarif: Tarif;
}

const PricingCard: React.FC<PricingCardProps> = ({ tarif }) => {
  return (
    <div className="flex flex-col h-full bg-white rounded-lg shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-2xl hover:-translate-y-1">
      <div className="bg-green-700 py-6 px-4 text-center">
        <h3 className="text-xl font-bold text-white">{tarif.categorie}</h3>
      </div>
      
      <div className="p-6 flex-grow flex flex-col">
        <div className="text-center mb-6">
          <span className="text-4xl font-bold text-green-800">{tarif.prix}€</span>
        </div>
        
        <p className="text-gray-600 text-center mb-6 flex-grow">
          {tarif.description}
        </p>
        
        <button className="w-full bg-yellow-500 hover:bg-yellow-600 text-white py-3 px-4 rounded-md font-semibold transition-colors duration-300">
          Réserver
        </button>
      </div>
    </div>
  );
};

export default PricingCard;
